import claimDataReducer from "./claimData"
import uiDataReducer from "./uiData"

import { combineReducers } from "redux"

const allReducers = combineReducers({
  claimData: claimDataReducer,
  uiData: uiDataReducer,
})

export default allReducers
